import { topicsData } from '@/mocks/homeData';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 hover:bg-primary-200',
  accent: 'bg-accent-100 text-accent-700 hover:bg-accent-200',
  secondary: 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-secondary-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热门话题</h2>
        </div>

        <div className="flex flex-wrap gap-3">
          {topicsData.map((topic) => (
            <div
              key={topic.id}
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-all duration-200 ${colorMap[topic.color] || colorMap.primary}`}
            >
              <span className="text-sm font-medium whitespace-nowrap">{topic.name}</span>
              <span className="text-[11px] opacity-70 whitespace-nowrap">{topic.count}</span>
              <i className="ri-arrow-right-line text-xs opacity-60 group-hover:translate-x-0.5 transition-transform"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}